import { Injectable } from '@angular/core';
import { HttpGeneralService, OutpatientParms, StockModuleSettingsParms } from '../../../shared';
import { RegPatService } from '../../../pricing/reg-pat-service/reg-pat-service';
import { CONFIG } from '../../../shared/config';
import { DocManagementTrans } from '../../../document-management/interface/doc-manag-model';
import { CallData, TotalData } from '../../../call-center/call-center-reservation';
import { ApprovalRequest } from '../../../approvals';
import { ComprehensiveRequestDetail, ComprehensiveRequestMaster } from '../../comprehensive-examination-order/comprehensive-examination-order-setup.service';
import { OrderMaster } from '../../../orders/order-stepper/shared/order-master';
import { OrderDetails } from '../../../orders/order-stepper/shared/order-details';
import { GenSchReservedSlots } from '../../../orders/order-reception/order-reception/order-reception.service';
import { PatientData } from '../../../registeration/patients';
const reservationVisitUrl = CONFIG.baseUrls.reservationVisit;
const orderingUrl = CONFIG.baseUrls.ordering;
let stockTransUrl = CONFIG.baseUrls.StockTrans;
let callCenterReservation = CONFIG.baseUrls.emergencyReservation;
const patientsUrl = CONFIG.baseUrls.patients;


@Injectable()
export class OutPatReservationService {


    constructor(
        private _httpGeneralService: HttpGeneralService) { }

    getSpecialityServices(outpatientParms: OutpatientParms) {
        return this._httpGeneralService.add(outpatientParms, `${reservationVisitUrl}/SpecialityService`);
    }

    searchPatients(searchObj: RegPatService) {

        return this._httpGeneralService.add(searchObj, `${reservationVisitUrl}/searchSp`);
        // let body = JSON.stringify(searchObj);
        // var headers = new Headers();
        // headers.append('Content-Type', 'application/json');
        // this._spinnerService.show();

        // return this._http
        //    .post(, body, { headers: headers })
        //    .map((res: Response) => res.json().data)
        //    .catch(this._exceptionService.catchBadResponse)
        //    .finally(() => this._spinnerService.hide());
    }

    serviceEligibilityandCost(regPatServices: RegPatService[]) {
        return this._httpGeneralService.addCollection(regPatServices, `${orderingUrl}/serviceCost`);
    }

    getSpecialityDoctors(specialId: number, day: Date) {
        return this._httpGeneralService.getWith(`${reservationVisitUrl}/AllDoctor/${specialId}/${day}`);
    }

    getReservationVisits(outpatientParms: OutpatientParms) {
        return this._httpGeneralService.add(outpatientParms, `${reservationVisitUrl}/ReservationVisits`);
    }
    getReservationWorkFolw(outpatientParms: OutpatientParms) {
        return this._httpGeneralService.add(outpatientParms, `${reservationVisitUrl}/RegGetReservationWorkFolw`);
    }
    getReservationConfirmation(outpatientParms: OutpatientParms) {
        return this._httpGeneralService.add(outpatientParms, `${reservationVisitUrl}/RegGetReservationConfirmation`);
    }

    getDoctors(specialId: number) {
        return this._httpGeneralService.getWith(`${reservationVisitUrl}/Doctors/${specialId}`);
    }

    addPatientReservation(PatientReservation: PatientReservation) {
        return this._httpGeneralService.add(PatientReservation, `${reservationVisitUrl}`);
    }
    addPatientReservationFormDoctor(PatientReservation: PatientReservationDoc) {
        return this._httpGeneralService.add(PatientReservation, `${reservationVisitUrl}/addPatientReservationFormDoctor`);
    }

    changeServiceStatus(selectedService: RegPatService) {
        return this._httpGeneralService.add(selectedService, `${reservationVisitUrl}/ChangeStatus`);
    }

    SaveNotes(selectedService: RegPatService) {
        return this._httpGeneralService.update(selectedService.serial, selectedService, `${reservationVisitUrl}/SaveNotes`);
    }
    getStockModuleSettings(parms: StockModuleSettingsParms) {
        return this._httpGeneralService.add(parms, `${stockTransUrl}/GetStockModuleSettings`);
    }

    UpdateMedicalPatStatus(selectedService: RegPatService) {
        return this._httpGeneralService.update(selectedService.serial, selectedService, `${reservationVisitUrl}/UpdateMedicalPatStatus`);
    }

    delayReservationToAnotherTime(service: RegPatFollowups) {
        return this._httpGeneralService.add(service, `${reservationVisitUrl}/delayReservation`)
    }
    confarmationReservation(selectedService: RegPatService) {
        return this._httpGeneralService.post(selectedService, `${reservationVisitUrl}/confarmationReservation`)
    }
    getPatientFutureReservationByPatCode(selectedService: OutpatientParms) {
        return this._httpGeneralService.post(selectedService, `${reservationVisitUrl}/getPatientFutureReservationByPatCode`)
    }
    getFinancalPostionsForPatient(selectedService: OutpatientParms) {
        return this._httpGeneralService.post(selectedService, `${reservationVisitUrl}/getFinancalPostionsForPatient`)
    }
    addCallerData(patient: TotalData) {
        return this._httpGeneralService.add<TotalData>(patient, `${callCenterReservation}/AddCallerData`);
    }
    updatePatientReservationDoctorFromMonthlyMatrix(patient: CallData) {
        return this._httpGeneralService.add<CallData>(patient, `${callCenterReservation}/UpdatePatientReservationDoctorFromMonthlyMatrix`)
    }

    addPatient(patient: PatientData) {
        return this._httpGeneralService.add(patient, `${patientsUrl}`);

    }
}


export interface RegPatVisit {
    serial?: number;
    patCode?: number;
    visitNo?: number;
    episodeCode?: number;
    lastResidenceDate?: Date;
    isPregnancy?: boolean;
    patientGender?: number
    docId?: number;
    allRoom?: boolean;
    placeCode?: number;
    feedingType?: number;
    type?: number;
    // mobile:string;
    dischargeStatus?: number;
    cancelReason?: number;

    startDate?: Date;
    endDate?: Date;

    contractId?: number;
    cardSerial?: number;
    inTransferBodiesSerial?: number;
    patNameAr?: string;
    patNameEn?: string;
    dischargeRemarks?: string;
    addmissionRemarks?: string;
    transfer?: string
    chronic?: number;
    visitReason?: number;
    visitStatus?: number;
    bedInfo?: string;
    paymentOn?: number
    priResidenceDegreeSerial?: number;
    patCaseType?: number;
    medicalCaseType?: number;
    expectedLOS?: number;
    turnedDdoc?: number;
    visitSerial?: number
    serviceType?: number
    patFromOrder?: number;
    oldVisitSerial?: number;
    calledDocFlag?: number;
    visitDocuments?: { documentLookupCode: number; base64: string }[];
    ///////////////////////////////
    exitType?: number;
    diagnosiesAsText?: string;
    speciality?: number;
    eligibilityNo?: number;
    specialityId?: number;
    medicalProgramFlag?: number;
    regPatRequestsSerial?: number;
    requestType?: number;
    walkingPatientFlag?: number;
    transformedBy?: number;
    accidentPlace?: number;
    transformedFromPolice?: number;
    previousEntry?: number;
    nphiesSpecialtyID?: string;
    diagnosis?: string;
    fileDelivery?: string;
    lastVitalOperations?: string;
    resultsOflatestExaminations?: string;
    rays?: string;
    reasonForConversion?: string;
    crf?: string
    deb?: string
    spliteDate?: Date
    transDate?: Date
    totalMoney?: number;
    nphiesSiteEligibility?: string;
    nphiesEligibilityResponseID?: string;
    nphiesEligibilityRequestID?: string;
    nphiesEligibilityOfflineReference?: any
    nphiesEligibilityTransferReference ? :any;
    nphiesExtensionEligibilityType?: any
    incabutorTemperature?: string;
    incabutorNumber?: string;
    mentorNumber?: string;
    peep?: string;
    fio2?: string;
    mode?: string;
    surgicalProcedureScheduleSerial?: number;
    cashOrVisa?: number;
    consultation?: number
    servicesPercent?: number
    consultationPercentOrValue?: number
    nphiesNewBorn ?:number;

}

export interface RegPatEpisode {

    PatCode?: number;
    Serial?: number;
    serial?: number;
    StartDate: Date;
    EndDate?: Date;
    Remarks?: string;
    Descreptions?: string;
    DiagnosiesCode?: number;
    DiagText?: string;
}



export interface TherapeuticCards {

    code: number;
    contractId?: number;
    cardNo?: string;
    patientCode: number;
    startDate?: any;
    endDate: any;
    policyNumber: string;
    eligibilityNo?: number;
}


export interface PatientReservation {
    therapeuticCards: TherapeuticCards;
    regPatVisit: RegPatVisit;
    regPatEpisode: RegPatEpisode;
    regPatServices: RegPatService[];
    visitDocuments: DocManagementTrans[];
    callData?: CallData;
    comprehensiveRequestMaster?: ComprehensiveRequestMaster,
    comprehensiveRequestDetail?: RegPatService[],
    orderMaster?: OrderMaster,
    OrderDetails?: OrderDetails[],
    RegPatServicesOrderDetail?: RegPatService[];
    GenSchReservedSlots?: GenSchReservedSlots[];
    FutureReservedSlots?: GenSchReservedSlots[]
}
export interface PatientReservationDoc {

    regPatServices: RegPatService[];
    approvals: ApprovalRequest[];
}


export interface RegPatFollowups {
    serial?: number;
    patCode?: number;
    specialityId?: number;
    regPatServiceSerial?: number;
    periodInDays?: number;
    totalCount?: string;
    doneFollowUpCount?: number;
    expireDate?: Date;
    consultationDate?: Date;
    expireFlag?: number;
    followUpSerials?: string;
    delayOrFollowUp?: number;
}
